import React from 'react';
import { Box } from '@mui/material';
import TeamSubscriptionHeader from 'team/components/subscription/TeamSubscriptionHeader';
import TeamSubscriptionList from 'team/components/subscription/TeamSubscriptionList';

const TeamSubscriptionContainer = () => {
    return (
        <Box sx={{ p: 4 }}>
            <TeamSubscriptionHeader />
            <TeamSubscriptionList />
        </Box>
    );
};

export default TeamSubscriptionContainer;
